import Card from "../../components/Cards"
import data from "./data"
import {HiCheck } from "react-icons/hi";
import "./filialeservices.css"

const Filialeservices = () => {
	return (
		<section id="services">
			<h2 data-aos="fade-up" className="filialeservices_title">Services </h2>
			<p data-aos="fade-up" className="filialeservices_title-1"> <h4>We offer you the best in the services below</h4></p>
			<div className="container filialeservices__container" data-aos="fade-up">
			{data.map(item =>(<a href={item.link}>
							<Card key={item.id} className="filialeservices light" >
							 <div className="filialeservices__img" data-aos="fade-right"><img src={item.icon}alt="" /></div>
							 <div className="filialeservices__details" data-aos="fade-right">
								<h4>{item.title}</h4>
								<p>
									<span className="desc_icon">
										<HiCheck />
									</span>{" "}
									{item.desc1}
								</p>
								<p>
									<span className="desc_icon">
										<HiCheck />
									</span>{" "}
									{item.desc2}
								</p>
								<p>
									<span className="desc_icon">
										<HiCheck />
									</span>{" "}
									{item.desc3}
								</p>
								<p>
									<span className="desc_icon">
										<HiCheck />
									</span>{" "}
									{item.desc4}
								</p>
							 </div> 
							</Card> 
							</a>
						))}
			</div>
		</section>
	)
}

export default Filialeservices